import React from 'react';
import "./navbar.css";
import logo from "../../assets/Link.svg";
import Navlink from '../navlink/navlink';
import Blackbtn from '../blackbtn/blackbtn';
import burger from "../../assets/burger.svg"
import x from "../../assets/x.svg"
import  { useState } from 'react';
import { Link } from "react-router-dom";


const Navbar = () => {

    const [isOpen, setIsOpen] = useState(false);

    const openMenu = () => {
        setIsOpen(true);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="nav">
                <img src={logo} alt="logo" className='logo' />

                <ul>
                    <Navlink s="linka" name="Home" link="/" />
                    <Navlink s="link" name="Properties" link="/list" />
                    <Navlink s="link" name="Services" link="/services" />
                    <Navlink s="link" name="Contact" link="/contact" />
                </ul>

                <div className="navbtns">
                    <img className='burger' id='burger' onClick={openMenu} src={burger} alt="" />
                    <h3>Login</h3>
                    <Blackbtn name="Sign Up" css1="blackbtn" />
                </div>

                <div className="burgerpage" style={{ display: isOpen ? "flex" : "none" }}>
                    <div className="linksburg">
                    <Link to="/" onClick={closeMenu}><span>Home</span></Link>
            <Link to="/list" onClick={closeMenu}><span>Properties</span></Link>
            <Link to="/services" onClick={closeMenu}><span>Services</span></Link>
            <Link to="/contact" onClick={closeMenu}><span>Contact</span></Link>

                    </div>

                    <img src={x} onClick={closeMenu} alt="" id='close' />

                </div>

            </div>
        
        
        </>
    );
}
export default Navbar;